import React from 'react';
import {
    Box,
    Avatar,
    Typography,
    createStyles,
    makeStyles,
    Theme,
    useTheme,
    useMediaQuery,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { user } from '€slices/user';
// import { initials } from '€lib/fp';

import { Hidden } from '€components/Hidden';
import MuiRouterLink from '../MuiRouterLink';
import { Routes } from '../../lib/routing';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        grey: {
            backgroundColor: theme.palette.text.primary,
        },
    }),
);

const TopBarAvatar = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const $user = useSelector(user);
    const classes = useStyles();

    // const userName = useMemo(
    //     () => $user && `${$user.profile.firstName} ${$user.profile.lastName}`,
    //     [$user],
    // );

    return (
        <>
            <MuiRouterLink
                to={{
                    pathname: `${matches ? Routes.UserDetails : Routes.UserSettings}`,
                    state: {
                        path: Routes.Dashboard,
                    },
                }}
                underline="none"
            >
                <Box
                    pb={{ xs: 0, sm: 1 }}
                    ml={{ xs: 0, md: 4.5 }}
                    display="flex"
                    alignItems="center"
                >
                    <Avatar className={classes.grey}>{$user.initials}</Avatar>
                    <Hidden xsDown>
                        <Box ml={1}>
                            <Typography noWrap variant="h6">
                                {$user.name}
                            </Typography>
                        </Box>
                    </Hidden>
                </Box>
            </MuiRouterLink>
        </>
    );
};

export default TopBarAvatar;
